module.exports = __webpack_public_path__ + "img/ios-flask.1efc53c7.svg";